export default function () {
    let videoLinks = [
        {
            videoUrl:
                'https://marine-debris.s3.ap-northeast-1.amazonaws.com/videos/2020%E5%B0%8F%E5%AF%B6rethink_+%E4%B8%AD%E6%96%87_final.mp4',
            title: '2020年 海洋廢棄物循環利用宣導影片（中文5分鐘版）',
            enTitle:
                'The 2020 Recycled Marine Debris Product Label Promotional Video (the five-minute Chinese version)',
            imgUrl: require('@/assets/png/video/2020-5min-ch.jpg'),
        },
        {
            videoUrl:
                'https://marine-debris.s3.ap-northeast-1.amazonaws.com/videos/%E5%B0%8F%E5%AF%B6rethink_%E8%8B%B1%E6%96%87_final(2020%E5%B9%B45%E5%88%86%E9%90%98).mp4',
            title: '2020年 海洋廢棄物循環利用宣導影片（英文5分鐘版）',
            enTitle:
                'The 2020 Recycled Marine Debris Product Label Promotional Video (the five-minute version)',
            imgUrl: require('@/assets/png/video/2020-5min-en.jpg'),
        },
        {
            videoUrl:
                'https://marine-debris.s3.ap-northeast-1.amazonaws.com/videos/%E7%B2%BE%E7%B0%A1%E7%89%88%E7%B7%A8%E8%BC%AF%E6%AA%94%E6%A1%88+1100608%E4%B8%AD%E6%96%87%E7%89%88V2(20203%E5%88%86%E9%90%98).mp4',
            title: '2020年 海洋廢棄物循環利用宣導影片（中文3分鐘版）',
            enTitle:
                'The 2020 Recycled Marine Debris Product Label Promotional Video (the three-minute Chinese version)',
            imgUrl: require('@/assets/png/video/2020-3min-ch.jpg'),
        },
        {
            videoUrl:
                'https://marine-debris.s3.ap-northeast-1.amazonaws.com/videos/%E7%B2%BE%E7%B0%A1%E7%89%88%E7%B7%A8%E8%BC%AF%E6%AA%94%E6%A1%88+1100618%E8%8B%B1%E6%96%87%E7%89%88(2020%E5%B9%B43%E5%88%86%E9%90%98).mp4',
            title: '2020年 海洋廢棄物循環利用宣導影片（英文3分鐘版）',
            enTitle:
                'The 2020 Recycled Marine Debris Product Label Promotional Video (the three-minute version)',
            imgUrl: require('@/assets/png/video/2020-3min-en.jpg'),
        },
        {
            videoUrl:
                'https://marine-debris.s3.ap-northeast-1.amazonaws.com/videos/2021%E5%B9%B4%E6%B5%B7%E5%BB%A2%E5%AE%A3%E5%B0%8E%E5%BB%A3%E5%91%8A_5%E5%88%86%E9%90%98_%E4%B8%AD%E6%96%87.mp4',
            title: '2021年 海洋廢棄物循環利用宣導影片（中文5分鐘版）',
            enTitle:
                'The 2021 Recycled Marine Debris Product Label Promotional Video (the five-minute Chinese version)',
            imgUrl: require('@/assets/png/video/2021-5min-ch.jpg'),
        },
        {
            videoUrl:
                'https://marine-debris.s3.ap-northeast-1.amazonaws.com/videos/%E6%B5%B7%E5%BB%A2%E5%AE%A3%E5%B0%8E%E5%BB%A3%E5%91%8A%EF%BC%BF5%E5%88%86%E9%90%98%EF%BC%BF2021%E8%8B%B1%E6%96%87-003.mp4',
            title: '2021年 海洋廢棄物循環利用宣導影片（英文5分鐘版）',
            enTitle:
                'The 2021 Recycled Marine Debris Product Label Promotional Video ',
            imgUrl: require('@/assets/png/video/2021-5min-en.jpg'),
        },
    ]

    return { videoLinks }
}
